import React from "react";
import About from "../../Components/About";
import Banner from "../../Components/Banner";
import Contact from "../../Components/Contact";

import Projects from "../../Components/Projects";

const Home = () => {
  return (
    <div className="space-y-24 lg:space-y-48">
      <Banner />
      <About />
      <Projects />
      <Contact />
    </div>
  );
};

export default Home;
